import { adaptV4Theme, createTheme } from '@mui/material/styles';

import colors from '../../styles/colors.module.scss';

const theme = createTheme(
  adaptV4Theme({
    typography: {
      fontFamily: ['Nunito Sans', 'sans-serif'].join(','),
    },
    overrides: {
      MuiMenuItem: {
        root: {
          color: colors.lightBlack,
          '&.Mui-selected:not(.checkbox-select)': {
            backgroundColor: colors.primary,
            borderRadius: 5,
            color: colors.white,
          },
          '&.Mui-selected.checkbox-select-new': {
            backgroundColor: '#F0F0F1 !important',
            borderRadius: 5,
            color: colors.lightBlack,
          },
          '& .Mui-checked.checkbox-select-new': {
            color: colors.lightBlack + '!important',
          },
          '&:hover': {
            backgroundColor: 'var(--primary-m2)',
          },
        },
      },
      MuiCheckbox: {
        root: {
          color: 'var(--primary-p3)',
        },
      },
      MuiButton: {
        root: {
          borderRadius: 100,
          fontFamily: 'Nunito Sans',
          fontStyle: 'normal',
          fontWeight: 600,
          fontSize: 14,
          textAlign: 'center',
          textTransform: 'unset',
          padding: '10px 24px 10px 16px',
          boxShadow: 'none',
          svg: {
            marginRight: '8px',
          },
        },
        containedPrimary: {
          background: 'var(--primary)',
          svg: {
            fontSize: '1rem',
            color: 'var(--white)',
          },
          '&:hover': {
            opacity: 1,
            boxShadow: '0px 2px 12px 0px rgba(0, 0, 0, 0.25)',
          },
          '&:disabled': {
            color: colors.lightWhite,
            background: 'rgba(15, 49, 87, 0.60)',
          },
        },
        outlinedInfo: {
          border: '1px solid var(--neutrals-n-200)',
          color: 'var(--primary)',
          '&:hover': {
            background: 'var(--neutrals-n-50)',
            border: '1px solid var(--neutrals-n-200)',
            opacity: 1,
          },
          '&:disabled': {
            color: 'var(--neutrals-n-300)',
            border: '1px solid var(--neutrals-n-200)',
          },
        },
        outlinedPrimary: {
          border: '1px solid var(--neutrals-n-200)',
          background: 'var(--white)',

          svg: {
            fontSize: '1rem',
            color: colors.primary,
          },
          '&:hover': {
            background: 'var(--neutrals-n-50)',
            border: '1px solid var(--neutrals-n-200)',
            opacity: 1,
          },
          '&:disabled': {
            color: 'var(--neutrals-n-300)',
            border: '1px solid var(--neutrals-n-200)',
          },
        },
        textInfo: {
          color: 'var(--primary-p3)',
        },
        textPrimary: {
          svg: {
            fontSize: '1rem',
            color: colors.primary,
          },
          '&:hover': {
            color: 'rgba(15, 49, 87, 0.70)',
            opacity: 1,
            backgroundColor: 'transparent',
          },
          '&:disabled': {
            color: 'var(--neutrals-n-200)',
          },
        },
        containedSecondary: {
          backgroundColor: colors.lightGreen,
          color: colors.lightBlack,
          '&:hover': {
            backgroundColor: colors.lightGreen,
            color: colors.lightBlack,
          },
        },
        text: {
          padding: '6px 8px',
        },
      },

      MuiInput: {
        input: {
          color: colors.lightBlack,
        },
      },
      MuiTableCell: {
        root: {
          color: colors.lightBlack,
        },
      },
      MuiPaper: {
        root: {
          color: colors.lightBlack,
        },
      },
      MuiOutlinedInput: {
        input: {
          color: colors.lightBlack,
        },
      },
      MuiIconButton: {
        root: {
          padding: '12px',
        },
      },
      MuiSelect: {
        select: {
          '&:focus': {
            backgroundColor: 'transparent',
          },
        },
      },
      MuiTooltip: {
        tooltip: {
          borderRadius: '4px',
          background: 'var(--neutrals-n-300)',
          padding: '8px',
          color: 'var(--white)',
          fontSize: '14px',
        },
      },
      MuiSwitch: {
        colorPrimary: {
          color: colors.disabledColor,
          padding: '3px 7px',
          '&$checked': {
            color: colors.lightGray,
          },
        },
        switchBase: {
          '&.Mui-disabled': {
            '&+.MuiSwitch-track': {
              backgroundColor: colors.lightGray,
            },
          },
          '&.Mui-checked': {
            '&+.MuiSwitch-track': {
              border: '0px',
            },
            '&.Mui-disabled': {
              color: '#9A9A9A !important',
            },
          },
        },
      },
      MuiDialog: {
        paper: {
          backgroundColor: colors.white,
          boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.15)',
          borderRadius: '5px',
        },
      },
    },
    palette: {
      primary: {
        main: colors.primary,
        contrastText: colors.white,
      },
      error: {
        main: colors.red,
      },
      info: {
        main: colors.blue,
      },
    },
    props: {
      MuiTextField: {
        variant: 'standard',
      },
      MuiSelect: {
        variant: 'standard',
      },
      MuiButton: {
        color: 'inherit',
      },
    },
  }),
);

export default theme;
